import { jsx as _jsx } from "react/jsx-runtime";
import { Form } from '../../Form';
/**
 * `LayoutForm` is a generic React component for creating forms within the application.
 * It is built on top of 'react-hook-form' for form state management and validation.
 * The component provides a structured way to create and handle forms with various field types and validation rules.
 *
 * @template TData - The type of data for the form. It should extend from FieldValues of 'react-hook-form'.
 * @param {Props<TData>} props - The properties passed to the LayoutForm component. These include:
 * @param {TData} data - The initial data for the form fields.
 * @param {(data: TData) => void} onSubmit - The function to be called when the form is submitted.
 * @param {ReactNode} children - Child components or elements, typically form fields, that will have access to form control methods.
 * @param {Control<TData>} control - Child prop: The control object from 'react-hook-form', used for managing the state of form fields.
 * @param {UseFormGetValues<TData>} getValues - Child prop: Function to get form values.
 * @param {UseFormSetValue<TData>} setValue - Child prop: Function to set form values.
 * @param {UseFormWatch<TData>} watch - Child prop: Function to watch form values.
 * @param {FieldErrors<TData>} errors - Child prop: Object containing any validation errors.
 */
export const LayoutForm = ({ data, isDisabled = false, onSubmit, onError, children }) => {
    return (_jsx(Form, Object.assign({ values: data, onSubmit: onSubmit, onError: onError }, { children: ({ control, getValues, setValue, watch, errors }) => (children({ control, getValues, setValue, watch, errors })) })));
};
